import 'twin.macro'

import FileDeleteIcon from 'assets/icons/file-delete-icon.svg?component'
import FileSmallIcon from 'assets/icons/file-earmark-icon.svg?component'
import tw, { TwStyle } from 'twin.macro'

import Typography from '../Typography'

type FileChipProps = {
  title: string
  twChipStyle?: TwStyle
  twTextStyle?: TwStyle
  onRemoveChip?: () => void
}

const FileChip = ({ title, twChipStyle, twTextStyle, onRemoveChip }: FileChipProps) => {
  return (
    <div
      css={[tw`bg-tertiary rounded-full inline-flex items-center gap-x-1 py-0.5 px-2 text-primary-dark`, twChipStyle]}
    >
      <FileSmallIcon tw='flex-shrink-0 text-sm' />
      <Typography variant='subbody' twStyle={[tw`truncate max-w-[100px]`, twTextStyle]}>
        {title}
      </Typography>
      <FileDeleteIcon onClick={onRemoveChip} tw='flex-shrink-0 cursor-pointer' />
    </div>
  )
}

export default FileChip
